var exports = {
  "Ou": "UnderlineNav__rioNiv",
  "lF": "ActionList__tvxuWP",
};

module.exports = exports;
